export const HOURS_CONTRACT_CODES = {
  500: 'error.internalServer',
  404: 'error.notFound.hoursContract',
  409: 'error.conflict.hoursContract'
};
